import React, { useEffect, useRef, useState } from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import Icon from 'components/Icon';
import './index.sass';

const { block, el } = bem('details');

const Details = ({ children, detailsText = 'Подробнее' }) => {

    const [height, setHeight] = useState(0);
    const [textHeight, setTextHeight] = useState(0);
    const ref = useRef(null);
    const textRef = useRef(null);
    const onResize = () => {
        if (ref.current) {
            setHeight(ref.current.getBoundingClientRect().height);
        }
        if (textRef.current) {
            setTextHeight(textRef.current.getBoundingClientRect().height);
        }
    }

    const open = () => {
        setVisible(true)
    }

    const close = () => {
        setVisible(false)
    }

    useEffect(() => {
        const resizeObserver = new ResizeObserver(onResize)
        if (ref.current) {
            resizeObserver.observe(ref.current)
            onResize()
        }
        if (textRef.current) {
            resizeObserver.observe(textRef.current);
            onResize()
        }
        return () => {
            resizeObserver.disconnect();
        }
    }, [ref.current])

    const [ visible, setVisible ] = useState(false)

    return (
        <div className={block()}>
            <div className={el('hidden-part', {visible})} style={{ height: visible ? `${height + 8}px` : 0 }}>
                <div className={el('grid-inner')} ref={ref} >
                    {children}
                </div>
            </div>
            <div className={el('detailed-text-container')} style={{height: `${textHeight}px`}}>
                <div className={el('detailed-text', 'show', { visible: !visible })} onClick={open} ref={textRef}>
                    <Text>{detailsText}</Text>
                    <Icon name={'caret-down'}/>
                </div>
                <div className={el('detailed-text', 'hide', { visible: visible })} onClick={close}>
                    <Text>Скрыть</Text>
                    <Icon name={'caret-down'}/>
                </div>
            </div>
        </div>
    )
}

export default Details;
